import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon, CalendarIcon, FileTextIcon } from 'lucide-react';
import { quotationMeta } from '../data/quotation';
import { formatEuro } from '../utils/pricing';
interface HeroProps {
  total: number;
  campaigns: number;
  recurring: number;
}
export function Hero({
  total,
  campaigns,
  recurring
}: HeroProps) {
  const summary = [{
    label: 'Year-one investment',
    value: formatEuro(total)
  }, {
    label: 'Campaign fees',
    value: formatEuro(campaigns)
  }, {
    label: 'Annual platform licence',
    value: formatEuro(recurring)
  }];
  return <section id="top" className="bg-white" data-id="element-27" data-mp="sarvuvlzhael">
      <div className="mx-auto w-full max-w-7xl px-5 pb-20 pt-14 sm:px-8 sm:pt-20" data-id="element-28" data-mp="s9q8brns6vfz">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-29" data-mp="nbexbdlr2ew6">
          <div className="mb-8 flex flex-wrap items-center gap-3 text-xs" data-id="element-30" data-mp="382ffxqfwf8fz">
            <span className="rounded-full bg-primary px-3 py-1 font-medium text-white" data-id="element-31" data-mp="384jud2bfbpui">
              Interactive quotation
            </span>
            <span className="inline-flex items-center gap-1.5 text-ink-300" data-id="element-32" data-mp="3o858h3cjnn0v">
              <FileTextIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-33" data-mp="39acx8ne15ksh" />
              Ref {quotationMeta.reference}
            </span>
            <span className="inline-flex items-center gap-1.5 text-ink-300" data-id="element-34" data-mp="3e8egb8bghk3y">
              <CalendarIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-35" data-mp="30hhq1o505f02" />
              Valid until {quotationMeta.validUntil}
            </span>
          </div>

          <h1 className="max-w-4xl font-display text-4xl font-bold leading-[1.03] tracking-tight text-ink-900 sm:text-6xl" data-id="element-36" data-mp="35aubxqiar7p4">
            Website snakification for{' '}
            <span className="text-primary" data-id="element-37" data-mp="2vjpxqt0g3qvc">three corporate brands</span> across
            EU5
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-ink-500" data-id="element-38" data-mp="2hjoytj3qqtii">
            The goal is to integrate snak campaigns into brand strategies by
            October, starting with the corporate brands and the top EU5 markets
            where the need to create digital impact is highest. A central
            Control Tower gives Leo Pharma one view of every campaign in every
            market, and a proven path to scale to more countries, brands and
            campaigns.
          </p>
        </motion.div>

        <motion.dl initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.15
      }} className="mt-12 grid gap-px overflow-hidden rounded-2xl border border-line bg-line sm:grid-cols-3" data-id="element-39" data-mp="db2ede3uydmq">
          {summary.map(item => <div key={item.label} className="bg-surface p-6" data-id="element-40" data-mp="x14ohzlgsq9j">
              <dt className="text-xs uppercase tracking-[0.18em] text-ink-300" data-id="element-41" data-mp="x0l3ub4fjnrt">
                {item.label}
              </dt>
              <dd className="mt-3 font-display text-3xl font-bold tracking-tight text-ink-900" data-id="element-42" data-mp="3lqm2xztl37vg">
                {item.value}
              </dd>
            </div>)}
        </motion.dl>

        <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-43" data-mp="1x786nshfdzw8">
          <a href="#scope" className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" data-id="element-44" data-mp="21bpnbishnx2s">
            See the scope and investment
            <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-45" data-mp="2kyvo7jssrylu" />
          </a>
          <a href="#opportunity" className="text-sm font-medium text-ink-500 underline-offset-4 hover:text-ink-900 hover:underline" data-id="element-46" data-mp="2l0zzwnwxu1wo">
            Start with the opportunity
          </a>
        </div>
      </div>
    </section>;
}